<template>
    <b-container fluid>
        <hr/>
        <div class="flexRow">
            <h3>Tasks</h3>
            <v-spacer/>
            <v-switch
                    v-model="autoUpdate"
                    label="automatische update"
                    color="success"
                    hide-details
            ></v-switch>
        </div>
        <hr/>
        <div id="projectSelector">
            <div class="flexRow">
                <div class="col-md-2 col-12">
                    <h6>Projects</h6>
                    <v-skeleton-loader
                            :loading="this.loadingFilters"
                            transition='fade-transition'
                            ref="skeleton"
                            type="list-item">
                        <b-form-select v-model="selectedProject" :options="projectOptions"/>
                    </v-skeleton-loader>
                </div>
                <v-spacer/>
                <div class="col-md-2 col-12"
                     v-if="accountRole.some(role => ['ROLE_ADMIN', 'ROLE_DEVELOPER'].includes(role))">
                    <h6>Subscriber</h6>
                    <v-skeleton-loader
                            :loading="this.loadingFilters"
                            transition='fade-transition'
                            ref="skeleton"
                            type="list-item">
                        <b-form-select v-model="selectedSubscriber" :options="subscriberOptions"/>
                    </v-skeleton-loader>
                </div>
                <v-spacer/>
                <div class="col-md-2 col-12">
                    <h6>State</h6>
                    <v-skeleton-loader
                            :loading="this.loadingFilters"
                            transition='fade-transition'
                            ref="skeleton"
                            type="list-item">
                        <b-form-select v-model="selectedState" :options="stateOptions"/>
                    </v-skeleton-loader>
                </div>
                <v-spacer/>
                <div class="col-md-2 col-12">
                    <h6>From Date</h6>
                    <b-form-group>
                        <b-form-input
                                type="date"
                                id="orderStartDate"
                                v-model="fromDate"/>
                    </b-form-group>
                </div>
                <v-spacer/>
                <div class="col-md-2 col-12">
                    <h6>Till Date</h6>
                    <b-form-group :state="fromDateBeforeTillDate()">
                        <b-form-input
                                type="date"
                                id="orderStartDate"
                                v-model="tillDate"/>
                    </b-form-group>
                    <b-form-invalid-feedback :state="fromDateBeforeTillDate()">
                        Start date before end date.
                    </b-form-invalid-feedback>
                </div>
                <v-spacer/>
                <div class="col-md-1 col-12">
                    <h6>Update Page</h6>
                    <v-btn :style="primaryStyle" @click="refreshTasks" :disabled="!fromDateBeforeTillDate()">Refresh
                    </v-btn>
                </div>
            </div>
        </div>

        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped
                     :items="tasks"
                     :fields="[
                        'id',
                        'projectName',
                        'subscriberName',
                        'name',
                        'state',
                        'executedAt',
                        'queuedAt',
                        'data'
                     ]">
                <template slot="data" slot-scope="data">
                    <v-btn icon small :color="sitionColor" @click="showTaskDetails(data.item)">
                        <v-icon>mdi-card-search-outline</v-icon>
                    </v-btn>
                </template>
                <template slot="executedAt" slot-scope="data">
                    {{data.item.executedAt != null ? (new Date(data.item.executedAt)).toLocaleDateString() + " " + (new
                    Date(data.item.executedAt)).toLocaleTimeString() : ""}}
                </template>
                <template slot="queuedAt" slot-scope="data">
                    {{(new Date(data.item.queuedAt)).toLocaleDateString() + " " + (new
                    Date(data.item.queuedAt)).toLocaleTimeString()}}
                </template>
            </b-table>
        </v-skeleton-loader>

        <div id="PaginationButtons" class="flexRow paginationButtons">
            <v-spacer></v-spacer>
            <div class="pageNumbers">
                <h5>{{this.firstPage}}</h5>
            </div>
            <v-btn :disabled="firstPage === undefined || firstPage >= currentTaskRoute"
                   @click="goToFirstPage"
                   class="m-2"
                   icon>
                <v-icon large color="black">mdi-chevron-triple-left</v-icon>
            </v-btn>
            <v-btn :disabled="previousPage === undefined  || firstPage >= currentTaskRoute"
                   @click="goToPreviousPage"
                   class="m-2"
                   icon>
                <v-icon large color="black">mdi-chevron-left</v-icon>
            </v-btn>
            <div class="pageNumbers">
                <h5>{{this.currentPage}}</h5>
            </div>
            <div class="pageNumbers" v-if="currentPage != currentTaskRoute && currentTaskRoute != 0">
                <v-icon color="black" class="mdi-spin">mdi-loading</v-icon>
                <h6><i>{{this.currentTaskRoute}}</i></h6>
            </div>
            <v-btn :disabled="nextPage === undefined || lastPage <= currentTaskRoute"
                   @click="goToNextPage"
                   class="m-2"
                   icon>
                <v-icon large color="black">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn :disabled="lastPage === undefined || lastPage <= currentTaskRoute"
                   @click="goToLastPage"
                   class="m-2"
                   icon>
                <v-icon large color="black">mdi-chevron-triple-right</v-icon>
            </v-btn>
            <div class="pageNumbers">
                <h5>{{this.lastPage}}</h5>
            </div>
            <v-spacer></v-spacer>
        </div>
        <div>
            <p style="text-align: center"> last updated on: {{this.updatedTime}}</p>
        </div>

        <v-dialog v-model="taskDetailsPopUp" max-width="70vw" class="taskDetailDialog">
            <v-card>
                <v-toolbar flat>
                    <v-toolbar-title>Details</v-toolbar-title>
                    <v-spacer/>
                    <v-btn icon @click="taskDetailsPopUp = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider style="margin: 0"/>
                <v-tabs vertical :color="sitionColor" class="taskDetailTabs">
                    <v-tab>data</v-tab>
                    <v-tab>result</v-tab>
                    <v-tab v-if="accountRole.some(role => ['ROLE_ADMIN', 'ROLE_DEVELOPER'].includes(role))">meta data
                    </v-tab>
                    <v-tab v-if="accountRole.some(role => ['ROLE_ADMIN', 'ROLE_DEVELOPER'].includes(role))">actions
                    </v-tab>
                    <v-tab-item class="taskDetailTabItem">
                        <v-card flat>
                            <v-card-text>
                                <pre class="dialogText">{{JSON.stringify(taskDetails.data, null, 2)}}</pre>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="taskDetailTabItem">
                        <v-card flat>
                            <v-card-text>
                                <pre class="dialogText">{{taskDetails.result}}</pre>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="taskMetaDataTabItem">
                        <v-card flat>
                            <v-card-text>
                                <pre class="dialogText">{{JSON.stringify(taskDetails.metaData, null, 2)}}</pre>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="taskDetailTabItem">
                        <v-card flat>
                            <v-card-text
                                    v-if="accountRole.some(role => ['ROLE_ADMIN', 'ROLE_DEVELOPER'].includes(role))">
                                <h5>This task has be run: {{taskDetails.runCounter}} times</h5>
                                <div v-if="accountRole.some(role => ['ROLE_ADMIN', 'ROLE_DEVELOPER'].includes(role))">
                                    <v-spacer style="height: 20px"/>
                                    <input type="hidden" id="taskDataForCopy"
                                           :value="JSON.stringify(this.taskDetails.data)">
                                    <v-btn :style="primaryStyle" @click="copyData">Copy the task data</v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </v-dialog>

    </b-container>
</template>

<script>
    import TaskRepository from '../../repositories/task.repository';
    import AccountRepository from "../../repositories/account.repository";

    export default {
        data() {
            return {
                accountRole: ['ROLE_USER'],
                currentTaskRoute: "1",
                firstPage: undefined,
                lastPage: undefined,
                nextPage: undefined,
                previousPage: undefined,
                currentPage: undefined,
                updatedTime: "-",
                tasks: [],
                loadingIndex: false,
                taskDetails: {},
                taskDetailsPopUp: false,

                loadingFilters: false,
                projects: [{id: -1, name: 'All'},],
                selectedProject: -1,
                subscribers: [{id: -1, name: 'All'},],
                selectedSubscriber: -1,
                states: ['All'],
                selectedState: 'All',
                fromDate: null,
                tillDate: null,

                autoUpdate: true,
            }
        },
        created() {
            this.loadingIndex = true;
            this.loadingFilters = true;
            AccountRepository.getUserInfo().then(res => {
                this.accountRole = res.data.role;
            }).catch(error => {
                console.error(error);
                this.accountRole = ['ROLE_USER'];
            });
            TaskRepository.getFilterOptions().then(res => {
                this.projects = res.data['projects'].concat([{id: -1, name: 'All'}]);
                this.subscribers = res.data['subscribers'].concat([{id: -1, name: 'All'}]);
                this.states = res.data['states'].concat(['All']);
            }).catch(error => {
                console.error(error);
            }).finally(onFinally => {
                this.loadingFilters = false;
            });
            TaskRepository.getAll().then(res => {
                this.tasks = res.data['tasks'];
                this.updatedTime = res.data['time'];
                if (res.data['page'] !== undefined) {
                    this.currentPage = res.data['page']['currentPage'];
                    this.firstPage = res.data['page']['firstPage'];
                    this.lastPage = res.data['page']['lastPage'];
                    this.nextPage = res.data['page']['nextPage'];
                    this.previousPage = res.data['page']['previousPage'];
                }
            }).catch(error => {
                console.error(error);
            }).finally(onFinally => {
                this.loadingIndex = false;
                this.interval = window.setInterval(() => {
                    if (this.autoUpdate) {
                        console.log(this.autoUpdate);
                        this.refreshTasks();
                    }
                }, 17500);
            });
        },
        methods: {
            showTaskDetails(item) {
                this.taskDetails = item;
                this.taskDetailsPopUp = true;
            },
            refreshTasks() {
                TaskRepository.getTasks(this.currentTaskRoute, this.selectedProject, this.selectedSubscriber, this.fromDate, this.tillDate, this.selectedState).then(res => {
                    if (res.data['page'] === undefined || this.currentTaskRoute == 0 || (res.data['page'] !== undefined && res.data['page']['currentPage'] == 1) || (res.data['page'] !== undefined && res.data['page']['currentPage'] == this.currentTaskRoute)) {
                        this.tasks = res.data['tasks'];
                        this.updatedTime = res.data['time'];
                        if (res.data['page'] !== undefined) {
                            this.currentPage = res.data['page']['currentPage'];
                            this.firstPage = res.data['page']['firstPage'];
                            this.lastPage = res.data['page']['lastPage'];
                            this.nextPage = res.data['page']['nextPage'];
                            this.previousPage = res.data['page']['previousPage'];
                            if (this.currentTaskRoute >= this.lastPage) {
                                this.currentTaskRoute = this.lastPage;
                            }
                            if (this.currentTaskRoute <= this.firstPage) {
                                this.currentTaskRoute = this.firstPage;
                            }
                        }
                    }
                });
            },
            goToFirstPage() {
                this.currentTaskRoute = this.firstPage;
                this.refreshTasks();
            },
            goToLastPage() {
                this.currentTaskRoute = this.lastPage;
                this.refreshTasks();
            },
            goToNextPage() {
                this.currentTaskRoute = parseInt(this.currentTaskRoute) + 1;
                this.refreshTasks();
            },
            goToPreviousPage() {
                this.currentTaskRoute = parseInt(this.currentTaskRoute) - 1;
                this.refreshTasks();
            },
            fromDateBeforeTillDate() {
                return (this.fromDate < this.tillDate) || this.fromDate == null || this.tillDate == null || this.fromDate === "" || this.tillDate === "";
            },
            copyData() {
                let DataToCopy = document.querySelector('#taskDataForCopy');
                DataToCopy.setAttribute('type', 'text');
                DataToCopy.select();

                try {
                    let successful = document.execCommand('copy');
                    DataToCopy.setAttribute('type', 'hidden');
                    if (successful) {
                        this.$bvToast.toast('The data is succesfully copied to the clipboard.', {
                            title: `Data copied.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast('Oops, unable to copy, pls. refresh the page and try again.', {
                            title: `Can't copy.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                } catch (err) {
                    DataToCopy.setAttribute('type', 'hidden');
                    alert('Oops, unable to copy');
                    this.$bvToast.toast('Oops, unable to copy, pls. refresh the page and try again.', {
                        title: `Can't copy.`,
                        variant: 'danger',
                        solid: true
                    });
                }
            },
        },
        beforeRouteLeave: function (to, from, next) {
            clearInterval(this.interval);
            next();
        },
        computed: {
            projectOptions() {
                return this.projects.map(p => {
                    return {value: p.id, text: p.id + ": " + p.name};
                });
            },
            subscriberOptions() {
                return this.subscribers.map(p => {
                    return {value: p.id, text: p.id + ": " + p.name};
                });
            },
            stateOptions() {
                return this.states.map(p => {
                    return {value: p, text: p};
                });
            }
        }
    }
</script>

<style>
    .paginationButtons {
        align-items: center;
    }

    .pageNumbers {
        height: 36px;
        display: flex;
        align-items: center
    }

    .pageNumbers > h5 {
        margin: 0;
    }

    .pageNumbers > h6 {
        margin: 0;
    }

    .taskDetailDialog {
        height: 80vh;
        overflow-y: visible;
    }

    .taskDetailTabs {
        overflow-y: auto;
        height: 75vh;
    }

    .taskDetailTabItem {
        overflow-x: auto;
    }

    .taskDetailTabs > .v-tabs-items {
        overflow-Y: auto;
    }

</style>
